import React from 'react';
import LookUpNavigationContainer from 'PointOfSale/modules/lookup/container/LookUpNavigationContainer';

const CepSideBar = () => {
  return (
    <React.Fragment>
      <LookUpNavigationContainer />
    </React.Fragment>
  );
};

export default CepSideBar;



// WEBPACK FOOTER //
// ./src/pages/pointofsale/modules/cepCard/component/CepSideBar.js